import { reloadPage } from 'src/_shared/utils/reload-page/reloadPage';
import { allowAllExit } from 'src/_shared/utils/prevent-exit/preventExit';
import {
  DYNAMIC_MODAL_ACTIONS,
  DYNAMIC_MODAL_VIEWS,
} from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { ErrorView } from '../ErrorView';

export const NewVersionAvailableError = () => {
  return (
    <ErrorView
      id="new-version-available-error"
      dynamicModalView={DYNAMIC_MODAL_VIEWS.NewVersionAvailable}
      actionCallback={(action: DYNAMIC_MODAL_ACTIONS) => {
        switch (action) {
          case DYNAMIC_MODAL_ACTIONS.CONTINUE:
            allowAllExit();
            reloadPage();
            break;
          default:
            break;
        }
      }}
    />
  );
};
